<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="A3" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1g9kr0xc29cj31hc0u044d.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9kr10nagjj31hc0u0whh.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kr13s2k6j31hc0u0adz.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1g9kr172ez8j31hc0u00wp.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kr1aabbdj31hc0u0gp1.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1g9kr1idyo1j31hc0u043w.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1g9kr1lvs4sj31hc0u079x.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9kr1owyu2j31hc0u0ac0.jpg"/>
        <!-- <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kr1rlph3j31hc0u0jto.jpg"/> -->
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1g9kr1v32jdj31hc0u0ad0.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1gdwirb1jvej31hc0u0go4.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1g9kra0pyi5j30ku112dir.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g9kra3prxsj30ku112di5.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kra6oglij30ku11277t.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g9kra9pwsjj30ku112wgw.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1g9kracrv89j30ku11276e.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g9krakd46jj30ku11240r.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1g9krandfl8j30ku11242w.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1g9krar1hkuj30ku112wfl.jpg"/>
        <!-- <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9krau0dfzj30ku112jt3.jpg"/> -->
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9krawxzorj30ku112tb9.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9krb3ghmvj30ks112acc.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
export default {
    data(){
        return {
           
        }
    },
    methods:{
    }
}
</script>
<style scoped>

.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/n/pa_1.png);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/n/pa_2.png);
	margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/A/a3.vue